import { on, reducer } from 'ts-action';
import * as analyticsInfoActions from '../actions/analytics-info.actions';
import { AnalyticsInfoState } from '../types/analytics-state.types';

declare module 'react-redux' {
  interface DefaultRootState {
    analytics: AnalyticsInfoState;
  }
}

const getInitialState = (): AnalyticsInfoState => ({
  ruler: {
    interaction: 'click',
    timeStarted: 0,
  },
  ecg: {
    timeStarted: 0,
  },
});

export default reducer(
  getInitialState(),
  on(analyticsInfoActions.setRulerInteraction, (state, { interaction }) => {
    const ruler = { ...state.ruler, interaction };
    return {
      ...state,
      ruler,
    };
  }),
  on(analyticsInfoActions.setEcgTimeStarted, (state, { timestamp }) => {
    const ecg = { ...state.ecg, timeStarted: timestamp };
    return {
      ...state,
      ecg,
    };
  }),
  on(analyticsInfoActions.setRulerTimeStarted, (state, { timestamp }) => {
    const ruler = { ...state.ruler, timeStarted: timestamp };
    return {
      ...state,
      ruler,
    };
  }),
);
